





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductCategory, ProductItem, SoftwareItem } from '@/types';
import ProductCategoryTableHeader from '@/components/ProductCategory/ProductCategoryTableHeader';
import { MANUALLY_LOAD_THRESHOLD } from '@/sensefly.config';

@Component({
  components: {
    ProductCategoryTableHeader,
  },
})
export default class Table extends Vue {
  @Prop() public categoryTitle: string;
  @Prop() public headerItems: string[];
  @Prop() public category: ProductCategory<ProductItem | SoftwareItem>;
  public maxCount = MANUALLY_LOAD_THRESHOLD;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProductCategory/ProductCategoryTable/ProductCategoryTable.vue